module.exports = __webpack_public_path__ + "static/img/worry-4.ef6cfee.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/worry-4.png
// module id = Mx9l
// module chunks = 1